<template>
  <div>
    <b-row class="m-0">
      <b-col cols="12" md="5" class="my-2">
        <div class="p-3">
          <div class="text-justify mb-3">
            <strong class="fs_16" v-text="$lang.finalReportBehavioralTitle" />
            <span
              class="text-muted lh_30"
              v-text="finalReportBehavioralCaption"
            />
          </div>
          <i :class="`far fa-check-circle mr-2`" />
          <strong class="text-right" v-html="renderScore()" />
        </div>
      </b-col>
      <b-col cols="12" md="7" class="my-2">
        <div
          v-if="score"
          class="showInChart"
          :style="{ left: score - 2 + `%`, bottom: `43%` }"
        >
          <div class="line-chart"></div>
        </div>

        <barChart
          v-if="!isloading"
          :title="$lang.tabFiveChartTitle"
          :labelChart="labelChart"
          :backgroundColor="backgroundColor"
          :data="dataBar"
        />
      </b-col>
    </b-row>
    <b-row class="m-0">
      <b-col cols="12" md="12" class="my-2">
        <div class="bg-light rounded p-3">
          <matrixTable
            :title="$lang.finalReportBehavioralTitle2"
            :fields="matrixFields"
            :items="
              pathOr([], ['assessment_behavioral_aspects'], behavioralData)
            "
          />
        </div>
      </b-col>
      <b-col cols="12" md="12" class="my-2">
        <div class="bg-light rounded p-3">
          <strong class="fs_16" v-text="$lang.finalReportBehavioralTitle1" />
          <ul class="list-unstyled mt-3 ml-3">
            <li class="mb-3" v-for="(item, index) in inquiries" :key="index">
              <i :class="`fas fa-circle mr-2 text-secondary`" />
              <strong v-text="`${item.caption}: `" />
              <span class="text-muted" v-text="item.value" />
            </li>
          </ul>
        </div>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import { pathOr } from "ramda";
import barChart from "@/components/chart/barChart.js";
import matrixTable from "./matrixTable.vue";
export default {
  components: {
    barChart,
    matrixTable,
  },
  data() {
    return {
      backgroundColor: [
        "#ff0000",
        "#ff0000",
        "#ff0000",
        "#ff0000",
        "#ff0000",
        "#ff0000",
        "#ff0000",
        "#ffc107",
        "#ffc107",
        "#ffc107",
        "#ffc107",
        "#ffc107",
        "#ffc107",
        "#ffc107",
        "#ffc107",
        "#ffc107",
        "#28a745f2",
        "#28a745f2",
        "#28a745f2",
        "#28a745f2",
      ],
      dataBar: [
        2, 2, 3, 5, 4, 6, 7, 22, 33, 32, 42, 34, 30, 25, 30, 20, 25, 11, 13, 2,
      ],
      labelChart: [
        0.05, 0.1, 0.15, 0.2, 0.25, 0.3, 0.35, 0.4, 0.45, 0.5, 0.55, 0.6, 0.65,
        0.7, 0.75, 0.8, 0.85, 0.9, 0.95, 1,
      ],
      isloading: false,
      code: this.$route.params.code,
      behavioralData: {},
      score: 0,
      finalReportBehavioralCaption: `بهترین ابزار برای سنجش رفتار اخلاقی و اسلامی در تحقیقات است، از منابع تحقیق خواسته می‌شود مصادیق رفتار اخلاقی و اسلامی که در مخاطب مشاهده کرده‌اند را ذکر کنند، در صورتی که منابع متعدد نتوانند مصادیقی با جزییات اشاره کنند، داوطلب جزو داوطلبان پر ریسک محسوب می‌شود و چناچه مصادیق مثبت متعدد با جزییات ارائه گردد، وضعیت وی قابل قبول می‌باشد.`,
      matrixFields: [
        {
          key: "caption",
          label: "شاخص ارزیابی",
          isRowHeader: true,
          class: "text-center w-75",
          thClass: "bg-info p-1",
          tdClass: "bg-info text-left p-1",
        },
        {
          key: "score0",
          label: "اساتید مصاحبه",
          class: "text-center",
          thClass: "bg-info p-1",
          tdClass: "p-1",
        },
        {
          key: "score1",
          label: this.$lang.research_resource,
          class: "text-center",
          thClass: "bg-info p-1",
          tdClass: "p-1",
        },
      ],
    };
  },
  computed: {
    inquiries() {
      const data = pathOr([], ["inquiries"], this.behavioralData);
      return [
        {
          caption: "سوء پیشنه",
          value: pathOr(null, ["inquiry_soe_pishineh"], data),
        },
        { caption: "واجا", value: pathOr(null, ["inquiry_vaja"], data) },
        { caption: "حفا", value: pathOr(null, ["inquiry_hefa"], data) },
        {
          caption: "پلیس امنیت",
          value: pathOr(null, ["inquiry_police"], data),
        },
        {
          caption: "مدرک تحصیلی",
          value: pathOr(null, ["inquiry_madrak"], data),
        },
      ];
    },
  },
  created() {
    this.fetchData();
  },
  methods: {
    pathOr,
    renderScore() {
      const data = {
        خوب: "text-success",
        متوسط: "text-warning",
        ضعیف: "text-danger",
      };
      const score = pathOr("", ["score"], this.behavioralData);
      const state = pathOr("", ["state"], this.behavioralData);
      const cls = pathOr("text-secondary", [state], data);
      return this.$lang.finalReportIntuitionScore
        .replace("{0}", `<span class="${cls}">${score}%</span>`)
        .replace("{1}", `<span class="${cls}">${state}</span>`);
    },
    renderScoreClass(value = null) {
      value = (value && value.trim()) || value;
      const data = {
        خوب: "success",
        متوسط: "warning",
        ضعیف: "danger",
      };
      return pathOr("secondary", [value], data);
    },
    async fetchData() {
      try {
        this.isloading = true;
        this.$emit("setLoading", true);
        const url =
          this.$config.api_url +
          this.$config.report.final_report_behavioral.replace("{0}", this.code);

        const response = await this.$httpService.get(url);
        this.behavioralData = {
          ...pathOr({}, ["data", "data"], response),
        };
        this.score =
          this.behavioralData && this.behavioralData.score
            ? parseInt(this.behavioralData.score)
            : 0;
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.$emit("setLoading", false);
        this.isloading = false;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.showInChart {
  position: absolute;
}

.line-chart {
  background-color: springgreen;
  width: 10px;
  height: 30px;
  position: relative;

  &::after {
    bottom: -16px;
    content: "";
    position: absolute;
    width: 0;
    height: 0;
    border-left: 10px solid transparent;
    border-right: 10px solid transparent;
    border-top: 17px solid springgreen;
    right: -5px;
  }
}
</style>
